import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { FormsModule } from '@angular/forms';
import { HttpClientModule } from '@angular/common/http';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { InputTextModule } from 'primeng/inputtext';
import { SidebarModule } from 'primeng/sidebar';
import { BadgeModule } from 'primeng/badge';
import { RadioButtonModule } from 'primeng/radiobutton';
import { InputSwitchModule } from 'primeng/inputswitch';
import { RippleModule } from 'primeng/ripple';
import { AppMenuComponent } from './app.menu.component';
import { AppMenuitemComponent } from './app.menuitem.component';
import { RouterModule } from '@angular/router';
import { AppTopBarComponent } from './app.topbar.component';
import { AppFooterComponent } from './app.footer.component';
import { AppConfigModule } from './config/config.module';
import { AppSidebarComponent } from './app.sidebar.component';
import { AppLayoutComponent } from './app.layout.component';
import { AppNavRailComponent } from './app.nav-rail.component';
import { AppNavPanelComponent } from './app.nav-panel.component';
import { ToggleButtonModule } from 'primeng/togglebutton';
import { MenuModule } from 'primeng/menu';
import { MessageModule } from 'primeng/message';
import { TieredMenuModule } from 'primeng/tieredmenu';
import { ButtonModule } from 'primeng/button';
import { ConfirmDialogModule } from 'primeng/confirmdialog';
import { SkeletonModule } from 'primeng/skeleton';
import { MessagesModule } from 'primeng/messages';
import { SharedModule } from '../modules/shared/shared.module';
import { AddEditTaskPopupComponent } from '../modules/shared/add-edit-task-popup/add-edit-task-popup.component';
import { AddEditInventoryPopupComponent } from '../modules/shared/add-edit-inventory-popup/add-edit-inventory-popup.component';

@NgModule({
  declarations: [
    AppMenuitemComponent,
    AppTopBarComponent,
    AppFooterComponent,
    AppMenuComponent,
    AppSidebarComponent,
    AppNavRailComponent,
    AppNavPanelComponent,
    AppLayoutComponent,
  ],
  imports: [
    SharedModule,
    BrowserModule,
    FormsModule,
    HttpClientModule,
    BrowserAnimationsModule,
    InputTextModule,
    SidebarModule,
    BadgeModule,
    RadioButtonModule,
    InputSwitchModule,
    RippleModule,
    RouterModule,
    AppConfigModule,
    ToggleButtonModule,
    BadgeModule,
    MenuModule,
    MessageModule,
    TieredMenuModule,
    ButtonModule,
    ConfirmDialogModule,
    SkeletonModule,
    MessagesModule,
    SharedModule,
  ],
  exports: [
    AppLayoutComponent,
    AddEditTaskPopupComponent,
    AddEditInventoryPopupComponent,
  ],
})
export class AppLayoutModule {}
